export const ARN_VERSION_SEPARATOR = "-";
